





























import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtProperties from "@/components/pages/ProductCreate/properties.vue";
import gtAttribute from "@/components/pages/ProductCreate/attribute.vue";
import gtDescription from "@/components/pages/ProductCreate/description.vue";
import gtMedia from "@/components/pages/ProductCreate/media.vue";
import basicInfo from "@/components/pages/ProductCreate/basicInfo.vue";
const a = namespace("a");
@Component({
  components: {
    gtProperties,
    gtAttribute,
    gtDescription,
    basicInfo,
    gtMedia
  }
})
export default class spuTab extends Vue {
  @Prop({ default: false }) isEdit;
  @Prop({ default: false }) readonly;
  private vaildates = [];
  vaildateRegister(fn) {
    this.vaildates.push(fn);
  }
  vaildateRemove(fn) {
    let index = this.vaildates.findIndex(item => item === fn);

    if (index > -1) {
      this.vaildates.splice(index, 1);
    }
  }
  submit() {
    return Promise.all(this.vaildates.map(vaildate => vaildate()));
    // .then(res => {
    //   console.log("ddd", res);

    //   return res;
    // })
    // .catch(() => {
    //   return;
    // });
  }
}
